var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmpty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 216,
    viewBox: "0 0 360 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2811_27060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 118C204 104.745 193.255 94 180 94C166.745 94 156 104.745 156 118C156 131.255 166.745 142 180 142C193.255 142 204 131.255 204 118Z",
    fill: "#075B7E",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.5 113.5C180.5 113.224 180.276 113 180 113C179.724 113 179.5 113.224 179.5 113.5V118H175C174.724 118 174.5 118.224 174.5 118.5C174.5 118.776 174.724 119 175 119H179.5V123.5C179.5 123.776 179.724 124 180 124C180.276 124 180.5 123.776 180.5 123.5V119H185C185.276 119 185.5 118.776 185.5 118.5C185.5 118.224 185.276 118 185 118H180.5V113.5Z",
    fill: "#075B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C16 0.223858 16.2239 0 16.5 0H23.5C23.7761 0 24 0.223858 24 0.5C24 0.776142 23.7761 1 23.5 1H16.5C16.2239 1 16 0.776142 16 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0.5C32 0.223858 32.2239 0 32.5 0H39.5C39.7761 0 40 0.223858 40 0.5C40 0.776142 39.7761 1 39.5 1H32.5C32.2239 1 32 0.776142 32 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 0.5C48 0.223858 48.2239 0 48.5 0H55.5C55.7761 0 56 0.223858 56 0.5C56 0.776142 55.7761 1 55.5 1H48.5C48.2239 1 48 0.776142 48 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 0.5C64 0.223858 64.2239 0 64.5 0H71.5C71.7761 0 72 0.223858 72 0.5C72 0.776142 71.7761 1 71.5 1H64.5C64.2239 1 64 0.776142 64 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 0.5C80 0.223858 80.2239 0 80.5 0H87.5C87.7761 0 88 0.223858 88 0.5C88 0.776142 87.7761 1 87.5 1H80.5C80.2239 1 80 0.776142 80 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 0.5C96 0.223858 96.2239 0 96.5 0H103.5C103.776 0 104 0.223858 104 0.5C104 0.776142 103.776 1 103.5 1H96.5C96.2239 1 96 0.776142 96 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 0.5C112 0.223858 112.224 0 112.5 0H119.5C119.776 0 120 0.223858 120 0.5C120 0.776142 119.776 1 119.5 1H112.5C112.224 1 112 0.776142 112 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 0.5C128 0.223858 128.224 0 128.5 0H135.5C135.776 0 136 0.223858 136 0.5C136 0.776142 135.776 1 135.5 1H128.5C128.224 1 128 0.776142 128 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 0.5C144 0.223858 144.224 0 144.5 0H151.5C151.776 0 152 0.223858 152 0.5C152 0.776142 151.776 1 151.5 1H144.5C144.224 1 144 0.776142 144 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 0.5C160 0.223858 160.224 0 160.5 0H167.5C167.776 0 168 0.223858 168 0.5C168 0.776142 167.776 1 167.5 1H160.5C160.224 1 160 0.776142 160 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 0.5C176 0.223858 176.224 0 176.5 0H183.5C183.776 0 184 0.223858 184 0.5C184 0.776142 183.776 1 183.5 1H176.5C176.224 1 176 0.776142 176 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 0.5C192 0.223858 192.224 0 192.5 0H199.5C199.776 0 200 0.223858 200 0.5C200 0.776142 199.776 1 199.5 1H192.5C192.224 1 192 0.776142 192 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 0.5C208 0.223858 208.224 0 208.5 0H215.5C215.776 0 216 0.223858 216 0.5C216 0.776142 215.776 1 215.5 1H208.5C208.224 1 208 0.776142 208 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 0.5C224 0.223858 224.224 0 224.5 0H231.5C231.776 0 232 0.223858 232 0.5C232 0.776142 231.776 1 231.5 1H224.5C224.224 1 224 0.776142 224 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 0.5C240 0.223858 240.224 0 240.5 0H247.5C247.776 0 248 0.223858 248 0.5C248 0.776142 247.776 1 247.5 1H240.5C240.224 1 240 0.776142 240 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0.5C256 0.223858 256.224 0 256.5 0H263.5C263.776 0 264 0.223858 264 0.5C264 0.776142 263.776 1 263.5 1H256.5C256.224 1 256 0.776142 256 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 0.5C272 0.223858 272.224 0 272.5 0H279.5C279.776 0 280 0.223858 280 0.5C280 0.776142 279.776 1 279.5 1H272.5C272.224 1 272 0.776142 272 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 0.5C288 0.223858 288.224 0 288.5 0H295.5C295.776 0 296 0.223858 296 0.5C296 0.776142 295.776 1 295.5 1H288.5C288.224 1 288 0.776142 288 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 0.5C304 0.223858 304.224 0 304.5 0H311.5C311.776 0 312 0.223858 312 0.5C312 0.776142 311.776 1 311.5 1H304.5C304.224 1 304 0.776142 304 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 0.5C320 0.223858 320.224 0 320.5 0H327.5C327.776 0 328 0.223858 328 0.5C328 0.776142 327.776 1 327.5 1H320.5C320.224 1 320 0.776142 320 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 0.5C336 0.223858 336.224 0 336.5 0H343.5C343.776 0 344 0.223858 344 0.5C344 0.776142 343.776 1 343.5 1H336.5C336.224 1 336 0.776142 336 0.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 215.5C16 215.224 16.2239 215 16.5 215H23.5C23.7761 215 24 215.224 24 215.5C24 215.776 23.7761 216 23.5 216H16.5C16.2239 216 16 215.776 16 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 215.5C32 215.224 32.2239 215 32.5 215H39.5C39.7761 215 40 215.224 40 215.5C40 215.776 39.7761 216 39.5 216H32.5C32.2239 216 32 215.776 32 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 215.5C48 215.224 48.2239 215 48.5 215H55.5C55.7761 215 56 215.224 56 215.5C56 215.776 55.7761 216 55.5 216H48.5C48.2239 216 48 215.776 48 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 215.5C64 215.224 64.2239 215 64.5 215H71.5C71.7761 215 72 215.224 72 215.5C72 215.776 71.7761 216 71.5 216H64.5C64.2239 216 64 215.776 64 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 215.5C80 215.224 80.2239 215 80.5 215H87.5C87.7761 215 88 215.224 88 215.5C88 215.776 87.7761 216 87.5 216H80.5C80.2239 216 80 215.776 80 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 215.5C96 215.224 96.2239 215 96.5 215H103.5C103.776 215 104 215.224 104 215.5C104 215.776 103.776 216 103.5 216H96.5C96.2239 216 96 215.776 96 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 215.5C112 215.224 112.224 215 112.5 215H119.5C119.776 215 120 215.224 120 215.5C120 215.776 119.776 216 119.5 216H112.5C112.224 216 112 215.776 112 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 215.5C128 215.224 128.224 215 128.5 215H135.5C135.776 215 136 215.224 136 215.5C136 215.776 135.776 216 135.5 216H128.5C128.224 216 128 215.776 128 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 215.5C144 215.224 144.224 215 144.5 215H151.5C151.776 215 152 215.224 152 215.5C152 215.776 151.776 216 151.5 216H144.5C144.224 216 144 215.776 144 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 215.5C160 215.224 160.224 215 160.5 215H167.5C167.776 215 168 215.224 168 215.5C168 215.776 167.776 216 167.5 216H160.5C160.224 216 160 215.776 160 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 215.5C176 215.224 176.224 215 176.5 215H183.5C183.776 215 184 215.224 184 215.5C184 215.776 183.776 216 183.5 216H176.5C176.224 216 176 215.776 176 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 215.5C192 215.224 192.224 215 192.5 215H199.5C199.776 215 200 215.224 200 215.5C200 215.776 199.776 216 199.5 216H192.5C192.224 216 192 215.776 192 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 215.5C208 215.224 208.224 215 208.5 215H215.5C215.776 215 216 215.224 216 215.5C216 215.776 215.776 216 215.5 216H208.5C208.224 216 208 215.776 208 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 215.5C224 215.224 224.224 215 224.5 215H231.5C231.776 215 232 215.224 232 215.5C232 215.776 231.776 216 231.5 216H224.5C224.224 216 224 215.776 224 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 215.5C240 215.224 240.224 215 240.5 215H247.5C247.776 215 248 215.224 248 215.5C248 215.776 247.776 216 247.5 216H240.5C240.224 216 240 215.776 240 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 215.5C256 215.224 256.224 215 256.5 215H263.5C263.776 215 264 215.224 264 215.5C264 215.776 263.776 216 263.5 216H256.5C256.224 216 256 215.776 256 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 215.5C272 215.224 272.224 215 272.5 215H279.5C279.776 215 280 215.224 280 215.5C280 215.776 279.776 216 279.5 216H272.5C272.224 216 272 215.776 272 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 215.5C288 215.224 288.224 215 288.5 215H295.5C295.776 215 296 215.224 296 215.5C296 215.776 295.776 216 295.5 216H288.5C288.224 216 288 215.776 288 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 215.5C304 215.224 304.224 215 304.5 215H311.5C311.776 215 312 215.224 312 215.5C312 215.776 311.776 216 311.5 216H304.5C304.224 216 304 215.776 304 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 215.5C320 215.224 320.224 215 320.5 215H327.5C327.776 215 328 215.224 328 215.5C328 215.776 327.776 216 327.5 216H320.5C320.224 216 320 215.776 320 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 215.5C336 215.224 336.224 215 336.5 215H343.5C343.776 215 344 215.224 344 215.5C344 215.776 343.776 216 343.5 216H336.5C336.224 216 336 215.776 336 215.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 192.5C359 192.224 359.224 192 359.5 192C359.776 192 360 192.224 360 192.5V199.5C360 199.776 359.776 200 359.5 200C359.224 200 359 199.776 359 199.5V192.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 176.5C359 176.224 359.224 176 359.5 176C359.776 176 360 176.224 360 176.5V183.5C360 183.776 359.776 184 359.5 184C359.224 184 359 183.776 359 183.5V176.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 160.5C359 160.224 359.224 160 359.5 160C359.776 160 360 160.224 360 160.5V167.5C360 167.776 359.776 168 359.5 168C359.224 168 359 167.776 359 167.5V160.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 144.5C359 144.224 359.224 144 359.5 144C359.776 144 360 144.224 360 144.5V151.5C360 151.776 359.776 152 359.5 152C359.224 152 359 151.776 359 151.5V144.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 128.5C359 128.224 359.224 128 359.5 128C359.776 128 360 128.224 360 128.5V135.5C360 135.776 359.776 136 359.5 136C359.224 136 359 135.776 359 135.5V128.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 112.5C359 112.224 359.224 112 359.5 112C359.776 112 360 112.224 360 112.5V119.5C360 119.776 359.776 120 359.5 120C359.224 120 359 119.776 359 119.5V112.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 96.5C359 96.2239 359.224 96 359.5 96C359.776 96 360 96.2239 360 96.5V103.5C360 103.776 359.776 104 359.5 104C359.224 104 359 103.776 359 103.5V96.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 80.5C359 80.2239 359.224 80 359.5 80C359.776 80 360 80.2239 360 80.5V87.5C360 87.7761 359.776 88 359.5 88C359.224 88 359 87.7761 359 87.5V80.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 64.5C359 64.2239 359.224 64 359.5 64C359.776 64 360 64.2239 360 64.5V71.5C360 71.7761 359.776 72 359.5 72C359.224 72 359 71.7761 359 71.5V64.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 48.5C359 48.2239 359.224 48 359.5 48C359.776 48 360 48.2239 360 48.5V55.5C360 55.7761 359.776 56 359.5 56C359.224 56 359 55.7761 359 55.5V48.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 32.5C359 32.2239 359.224 32 359.5 32C359.776 32 360 32.2239 360 32.5V39.5C360 39.7761 359.776 40 359.5 40C359.224 40 359 39.7761 359 39.5V32.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 16.5C359 16.2239 359.224 16 359.5 16C359.776 16 360 16.2239 360 16.5V23.5C360 23.7761 359.776 24 359.5 24C359.224 24 359 23.7761 359 23.5V16.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 192.5C0 192.224 0.223858 192 0.5 192C0.776142 192 1 192.224 1 192.5V199.5C1 199.776 0.776142 200 0.5 200C0.223858 200 0 199.776 0 199.5V192.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 176.5C0 176.224 0.223858 176 0.5 176C0.776142 176 1 176.224 1 176.5V183.5C1 183.776 0.776142 184 0.5 184C0.223858 184 0 183.776 0 183.5V176.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 160.5C0 160.224 0.223858 160 0.5 160C0.776142 160 1 160.224 1 160.5V167.5C1 167.776 0.776142 168 0.5 168C0.223858 168 0 167.776 0 167.5V160.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 144.5C0 144.224 0.223858 144 0.5 144C0.776142 144 1 144.224 1 144.5V151.5C1 151.776 0.776142 152 0.5 152C0.223858 152 0 151.776 0 151.5V144.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 128.5C0 128.224 0.223858 128 0.5 128C0.776142 128 1 128.224 1 128.5V135.5C1 135.776 0.776142 136 0.5 136C0.223858 136 0 135.776 0 135.5V128.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 112.5C0 112.224 0.223858 112 0.5 112C0.776142 112 1 112.224 1 112.5V119.5C1 119.776 0.776142 120 0.5 120C0.223858 120 0 119.776 0 119.5V112.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 96.5C0 96.2239 0.223858 96 0.5 96C0.776142 96 1 96.2239 1 96.5V103.5C1 103.776 0.776142 104 0.5 104C0.223858 104 0 103.776 0 103.5V96.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.5C0 80.2239 0.223858 80 0.5 80C0.776142 80 1 80.2239 1 80.5V87.5C1 87.7761 0.776142 88 0.5 88C0.223858 88 0 87.7761 0 87.5V80.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 64.5C0 64.2239 0.223858 64 0.5 64C0.776142 64 1 64.2239 1 64.5V71.5C1 71.7761 0.776142 72 0.5 72C0.223858 72 0 71.7761 0 71.5V64.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 48.5C0 48.2239 0.223858 48 0.5 48C0.776142 48 1 48.2239 1 48.5V55.5C1 55.7761 0.776142 56 0.5 56C0.223858 56 0 55.7761 0 55.5V48.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32.5C0 32.2239 0.223858 32 0.5 32C0.776142 32 1 32.2239 1 32.5V39.5C1 39.7761 0.776142 40 0.5 40C0.223858 40 0 39.7761 0 39.5V32.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5C0 16.2239 0.223858 16 0.5 16C0.776142 16 1 16.2239 1 16.5V23.5C1 23.7761 0.776142 24 0.5 24C0.223858 24 0 23.7761 0 23.5V16.5Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H7.5C7.77614 0 8 0.223858 8 0.5C8 0.776142 7.77614 1 7.5 1H4C2.34315 1 1 2.34315 1 4V7.5C1 7.77614 0.776142 8 0.5 8C0.223858 8 0 7.77614 0 7.5V4Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 216C1.79086 216 0 214.209 0 212V208.5C0 208.224 0.223858 208 0.5 208C0.776142 208 1 208.224 1 208.5V212C1 213.657 2.34315 215 4 215H7.5C7.77614 215 8 215.224 8 215.5C8 215.776 7.77614 216 7.5 216H4Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 212C360 214.209 358.209 216 356 216H352.5C352.224 216 352 215.776 352 215.5C352 215.224 352.224 215 352.5 215H356C357.657 215 359 213.657 359 212V208.5C359 208.224 359.224 208 359.5 208C359.776 208 360 208.224 360 208.5V212Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 0C358.209 0 360 1.79086 360 4V7.5C360 7.77614 359.776 8 359.5 8C359.224 8 359 7.77614 359 7.5V4C359 2.34315 357.657 1 356 1H352.5C352.224 1 352 0.776142 352 0.5C352 0.223858 352.224 0 352.5 0H356Z",
    fill: "#075B7E",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2811_27060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 216,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty.d0076136f435484833dcc798dd4ff199.svg";